import { CellsModifiers } from 'types/CellsModifiers.types';
import { ExpenseFormNames, IExpenseItemV2 } from 'types/expenses.types';
import { AvailableLanguages } from 'types/users.types';
import {
  CATEGORY_TAXES_AND_INSURANCE_IMPORT_FEES,
  CATEGORY_TAXES_AND_INSURANCE_IMPORT_FEES_PLACEHOLDER,
  CATEGORY_TAXES_AND_INSURANCE_IMPORT_VAT,
} from 'utils/categories';

const expenses = {
  header: {
    helper: {
      title: 'de.expenses.deductible_costs',
      description: [
        'de.expenses.deductible_costs_helper_1',
        'de.expenses.deductible_costs_helper_2',
        'de.expenses.deductible_costs_helper_3',
        'de.expenses.deductible_costs_helper_4',
        'de.expenses.deductible_costs_helper_5',
      ],
      ctaDesc: 'question_on_topic',
      ctaText: 'talk_to_an_expert',
      onClick: (): void => {},
    },
  },
  hasDeductibilityField: false,
  filters: {
    is_invoice: false,
  },
  can_link_vehicle: false,
  can_pay_with_qr_code: true,
  hasTranslatedCategories: false,
  allow_bulk_mark_as_paid: false,
  vehicleCategoryIds: [],
  is_customer_company: (): boolean => false,
  is_start_date_required: (): boolean => false,
  is_amortization: (item: IExpenseItemV2, currencyRate = 1): boolean => {
    const category = item.category;
    if (!category?.suggestedAmortizationPeriod) return false;
    const amountThreshold = category.minAmortizationAmount ?? 250;
    return (item.currencyAmount || 0) / (currencyRate || 1) >= amountThreshold;
  },
  has_type: false,
  reverse_charge_helper: {
    title: 'expenses.helpers.reverse_charge_expense.title',
    description: [
      'expenses.helpers.reverse_charge_expense.text1',
      'expenses.helpers.reverse_charge_expense.text2',
    ],
  },
  vat_rates: [0, 0.07, 0.19],
  vat_rates_deductible_2020: [0.05, 0.16],
  default_vat_rate: 0.19,
  max_vat_rate: 0.19,
  list: {
    vat_inclusion_key: '',
    group_expenses: {
      web: 'isValidated',
      experts: 'reviewed',
    },
    cells: {
      _modifiers: [{ name: CellsModifiers.expenses }],
      // when a expense is highlighed we show only these columns
      cells_when_highlighted: ['SUPPLIER', 'CATEGORY', 'DATE', 'AMOUNT'],
      default_sort: {
        web: 'expenseDate_desc',
        experts: 'expenseDate_desc',
      },
      first_group: {
        web: [
          {
            cellName: 'SUPPLIER',
            headerName: 'expenses.cells.expenses_reviewed',
          },
          'DATE',
          'CATEGORY',
          'ATTACHMENT',
          'AMOUNT',
        ],
        experts: [
          {
            cellName: 'SUPPLIER',
            headerName: 'expenses.cells.expenses_validated',
          },
          'DATE',
          'CATEGORY',
          'ATTACHMENT',
          'AMOUNT',
          'REVIEWED',
        ],
      },
      second_group: {
        web: [
          {
            cellName: 'SUPPLIER',
            headerName: 'expenses.cells.expenses_to_review',
          },
          'DATE',
          {
            cellName: 'CATEGORY',
            headerName: 'expenses.cells.suggested_category',
          },
          'ATTACHMENT',
          'AMOUNT',
        ],
        experts: [
          {
            cellName: 'SUPPLIER',
            headerName: 'expenses.cells.expenses_to_validate',
          },
          'DATE',
          'CATEGORY',
          'ATTACHMENT',
          'AMOUNT',
        ],
      },
    },
  },

  blocked: {
    web: false,
    experts: false,
  },
  deductible_tax_categories: ['de.taxes_and_insurance.vat_payment'],
  all_you_can_deduct_link_origin: (lang: AvailableLanguages) => {
    const link = 'https://kannichdasabsetzen.accountable.de';
    if (lang === AvailableLanguages.de) return link;
    return link + '/' + lang;
  },
  includeVATAmountIfDeductible: true,
  import_vat_category: CATEGORY_TAXES_AND_INSURANCE_IMPORT_VAT,
  import_fees_category: CATEGORY_TAXES_AND_INSURANCE_IMPORT_FEES,
  import_fees_category_placeholder:
    CATEGORY_TAXES_AND_INSURANCE_IMPORT_FEES_PLACEHOLDER,
  taxLockEnabledFields: [ExpenseFormNames.transactions, ExpenseFormNames.notes],
};

export default expenses;
